module.exports = __webpack_public_path__ + "static/media/Customized_ending_message.e72abc4e.png";